import {configStore} from 'app/store/global';

export const getType = (type: string): string => {
    const promoActive = configStore.CONFIG?.promo_news_active ?? 0;

    return type === 'promotions' && promoActive <= 0
        ? 'promotions_old'
        : type;
};
